// extracted by mini-css-extract-plugin
module.exports = {"container":"i_PS","wrapper":"i_PT","body":"i_PU","input":"i_PV","label":"i_PW","mandatory":"i_PX","disallowed":"i_PY"};